import { Spinner, Text, VStack } from 'ui_2';
import { MysteryCityFriendPerformance } from './MysteryCityFriendPerformance';
import { ManageFriends } from './ManageFriends';
import { useEffectiveAccount } from '@src/hooks/useEffectiveAccount';
import { ConnectButton } from '@src/components/ConnectOrAccount';

export const FriendPageContents = () => {
  const { isReconnecting, isDisconnected, hasAuth } = useEffectiveAccount();

  if (isReconnecting) {
    return (
      <VStack className='w-full items-center justify-center gap-2 py-12'>
        <Spinner />
        <Text font='sm' color='gray-500'>
          Connecting...
        </Text>
      </VStack>
    );
  }

  if (isDisconnected) {
    return (
      <VStack className='w-full items-center justify-center gap-4 py-12'>
        <Text font='sm' color='gray-500'>
          Connect your wallet to see friends
        </Text>
        <ConnectButton />
      </VStack>
    );
  }

  if (!hasAuth) {
    return (
      <VStack className='w-full items-center justify-center gap-4 py-12'>
        <Text font='sm' color='gray-500'>
          Open this page in Puzzle Wallet to see friends
        </Text>
      </VStack>
    );
  }

  return (
    <VStack className='w-full items-center gap-4'>
      <ManageFriends />
      <MysteryCityFriendPerformance />
    </VStack>
  );
};
